/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Styles from "./styles";
import { ROUTES } from "../../utils/constants";

function Heading() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, type } = useParams();
  const handleBack = () => {
    navigate(-2);
  };
  const checkChangeToNewScreenPath = (originalPath, currentPath, id) =>
    originalPath === `/${currentPath?.split("/:")?.[0]}/${id}`;

  const checkTypeScreenPath = (originalPath, currentPath, type) =>
    originalPath === `/${currentPath?.split("/:")?.[0]}/${type}`;

  const checkTypeAndChangeToNewScreenPath = (
    originalPath,
    currentPath,
    type,
    id
  ) => originalPath === `/${currentPath?.split("/:")?.[0]}/${type}/${id}`;
  const removeSlashFromBeg = (originalPath) => {
    if (originalPath && originalPath[0] === "/") {
      return originalPath.slice(1);
    }
    return originalPath;
  };
  const getHeaderTitle = () => {
    let headerTitle = "";
    Object.keys(ROUTES).forEach((route) => {
      const currentPath = removeSlashFromBeg(ROUTES[route].path);
      if (
        location.pathname === `/${currentPath}` ||
        checkChangeToNewScreenPath(location.pathname, currentPath, id) ||
        checkTypeScreenPath(location.pathname, currentPath, type) ||
        (checkTypeAndChangeToNewScreenPath(
          location.pathname,
          currentPath,
          type,
          id
        ) &&
          ROUTES[route].headerTitle)
      ) {
        headerTitle = ROUTES[route].headerTitle;
      }
    });
    return headerTitle;
  };
  return (
    <Box sx={Styles.mainContainer}>
      <KeyboardBackspaceIcon
        onClick={handleBack}
        sx={{ color: "rgb(4, 61, 144)" }}
      />
      <Typography
        sx={{ fontSize: "14px", fontWeight: "400", color: "rgb(4, 61, 144)" }}
      >
        {getHeaderTitle()}
      </Typography>
    </Box>
  );
}

export default Heading;
